// Chaves de localStorage compartilhadas entre api/axios.js e contexts/*.jsx.
// Isoladas num módulo sem outras dependências de propósito — axios.js e EmpresaContext.jsx
// se importariam um ao outro em círculo se essa constante morasse em qualquer um dos dois.
export const EMPRESA_STORAGE_KEY = 'sf_id_empresa';

// Valor especial guardado em EMPRESA_STORAGE_KEY quando o super_admin escolhe o modo Global
// (ver todas as empresas de uma vez) em vez de uma empresa específica.
export const MODO_GLOBAL = '__global__';
